import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { getData } from "../config/api-connect";

const PermissionContext = createContext(null);

export function PermissionProvider({ children }) {
  const [permissions, setPermissions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    setLoading(true);
    getData("/buddy/check_user_permissions/")
      .then((response) => {
        if (!active) return;
        setPermissions(response && response.success ? response.permissions || [] : []);
      })
      .catch(() => {
        if (!active) return;
        setPermissions([]);
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, []);

  const hasPermission = useCallback(
    (codename) => permissions.includes(codename),
    [permissions],
  );

  const hasAccess = useCallback(
    // permission and role ( and is mode)
    //permission or role ( or is mode)
    //just permission then only filter by permission
    //just role  then only filter by role
    ({ roles = [], permission = "", mode = "or" } = {}) => {
      const userRole = localStorage.getItem("user_role");
      const roleMatch = roles.length === 0 ? null : roles.includes(userRole);
      const permissionMatch = permission ? permissions.includes(permission) : null;

      if (permission) {
        if (roles.length === 0) return permissionMatch;
        if (mode === "or") return roleMatch || permissionMatch;
        return roleMatch && permissionMatch;
      }
      return roles.length === 0 ? true : roleMatch;
    },
    [permissions],
  );

  const value = useMemo(
    () => ({ permissions, loading, hasPermission, hasAccess }),
    [permissions, loading, hasPermission, hasAccess],
  );

  return <PermissionContext.Provider value={value}>{children}</PermissionContext.Provider>;
}

export function usePermission() {
  const ctx = useContext(PermissionContext);
  if (!ctx) {
    throw new Error("usePermission must be used within a PermissionProvider");
  }
  return ctx;
}
